module.exports = __webpack_public_path__ + "static/media/8.88bd6b23.jpg";